/*--------------------------------------------------
ACCESSIBLITA'
--------------------------------------------------*/

function initSkipLinks() {
    $('.visually-hidden.skip-link').on('click', function (e) {
        e.preventDefault();

        var skipType = $(this).attr('data-skip');
        var $targetElement = null;

        switch (skipType) {
            case 'content':
                // Trova il primo elemento di contenuto dopo l'header
                $targetElement = $('.header').next();
                // Cerca un elemento principale se esiste
                var $mainContent = $('main, #main, .main-content, .content');
                if ($mainContent.length > 0) {
                    $targetElement = $mainContent;
                }
                break;
            case 'header':
                // Vai al primo elemento interattivo dell'header
                $targetElement = $('#header');
                var $firstHeaderLink = $targetElement.find('a, button').first();
                if ($firstHeaderLink.length > 0) {
                    $targetElement = $firstHeaderLink;
                }
                break;
            case 'footer':
                // Vai al footer e al suo primo elemento interattivo
                $targetElement = $('#footer, footer');
                var $firstFooterLink = $targetElement.find('a, button').first();
                if ($firstFooterLink.length > 0) {
                    $targetElement = $firstFooterLink;
                }
                break;
        }

        if ($targetElement && $targetElement.length > 0) {
            // Rendi l'elemento tabulabile se non lo è già
            if (!$targetElement.attr('tabindex')) {
                $targetElement.attr('tabindex', '-1');
            }

            // Focalizza l'elemento
            $targetElement.focus();

            // Imposta un identificatore temporaneo per lo scrolling
            var originalId = $targetElement.attr('id');
            if (!originalId) {
                $targetElement.attr('id', 'temp-focus-target');
            }

            // Scroll all'elemento
            var elementTop = $targetElement.offset().top - $('.header').outerHeight();
            $('html, body').animate({
                scrollTop: elementTop
            }, 'fast');

            // Rimuovi l'id temporaneo se necessario
            if (!originalId) {
                setTimeout(function () {
                    $targetElement.removeAttribute('id');
                }, 100);
            }
        }
    });
}

/*--------------------------------------------------
FOCUS TRAP PER ACCESSIBILITÀ
--------------------------------------------------*/
function initFocusTrap() {
    // Elementi iniziali per i pannelli modali
    var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
    var previousFocus = null;
    var currentModal = null;
    var trapIndex = 0;

    // Apri il pannello modale e attiva il focus trap
    $('[data-modal-button], [data-modal-button-mobile]').on('click', function (e) {
        e.preventDefault();

        // Determina quale modalId usare in base al contesto (dimensione dello schermo)
        var modalId;
        var isMobileButton = false;

        // Se la viewport è più piccola di una certa dimensione (es. 768px), 
        // usa l'attributo mobile, altrimenti usa quello standard
        if (window.innerWidth < 768 && $(this).attr('data-modal-button-mobile')) {
            modalId = $(this).attr('data-modal-button-mobile');
            isMobileButton = true;
        } else {
            modalId = $(this).attr('data-modal-button');
        }

        console.log('È un bottone mobile? ' + (isMobileButton ? 'Sì' : 'No'));

        // Se non c'è un modalId valido, esci
        if (!modalId) return;

        // Chiudi tutti i modal aperti prima di aprire il nuovo, ma solo su desktop
        if (window.innerWidth >= 768) {
            // Su desktop, chiudi altri modal aperti
            $('[data-modal-dialog].active').each(function () {
                var openModalId = $(this).attr('data-modal-dialog');
                // Evita di chiudere lo stesso modal che stiamo per aprire
                if (openModalId !== modalId) {
                    closeModal(openModalId);
                }
            });
        } else {
            // Su mobile, log informativo ma non chiudere altri modal
            console.log('Modalità mobile: mantengo aperti altri modal esistenti');
        }

        // Salva l'elemento con focus attuale
        previousFocus = document.activeElement;

        // Mostra il pannello modale, passando anche l'informazione se è un bottone mobile
        openModal(modalId, isMobileButton);
    });

    // Chiudi il pannello modale
    $('[data-modal-close]').on('click', function (e) {
        e.preventDefault();
        var modalId = $(this).attr('data-modal-close');

        console.log('Richiesta chiusura modal:', modalId);

        if (modalId === 'all') {
            // Chiudi tutti i modal e resetta la storia
            modalHistory = [];
            $('[data-modal-dialog]').each(function () {
                var id = $(this).attr('data-modal-dialog');
                closeModal(id);
            });
        } else {
            closeModal(modalId);

            // Importante: dopo aver chiuso un modal, assicurati che il modal corrente
            // (se esiste ancora nella storia) sia correttamente focalizzabile
            if (currentModal) {
                var $currentModal = $('[data-modal-dialog="' + currentModal + '"]');
                if ($currentModal.length > 0) {
                    setTimeout(function () {
                        var $focusable = $currentModal.find(focusableElementsString);
                        if ($focusable.length > 0) {
                            $focusable.first().focus();
                        } else {
                            $currentModal.focus();
                        }
                    }, 100);
                }
            }
        }
    });

    // Gestione tastiera per uscire dal modale con ESC
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && currentModal) {
            e.preventDefault();

            // Chiudi solo il modal corrente (l'ultimo nella gerarchia)
            closeModal(currentModal);
        } else if (e.key === 'Tab' && currentModal) {
            trapTabKey(e);
        }
    });

    // Aggiungi una variabile per tenere traccia della "storia" dei modal aperti
    var modalHistory = [];

    // Funzione per aprire il modale e impostare il focus
    function openModal(modalId, isMobileButton) {
        var $modal = $('[data-modal-dialog="' + modalId + '"]');

        if ($modal.length === 0) return;

        // Aggiungi alla storia dei modal solo se non è già l'ultimo elemento
        if (modalHistory.length === 0 || modalHistory[modalHistory.length - 1] !== modalId) {
            modalHistory.push(modalId);
            console.log('Storia modal aggiornata:', modalHistory);
        }

        currentModal = modalId;

        // Aggiungi la classe active al pannello
        $modal.addClass('active');

        // Se è un bottone mobile, aggiungi una classe specifica
        if (isMobileButton) {
            $modal.addClass('mobile-view');
        }

        // Imposta aria-hidden su false
        $modal.attr('aria-hidden', 'false');

        // Imposta tabindex=-1 sul dialogo per renderlo tabbabile
        $modal.attr('tabindex', '-1');

        // Disabilita lo scroll di sfondo
        $('body').addClass('modal-open');

        // Se è un bottone mobile, aggiungi una classe specifica al body
        if (isMobileButton) {
            $('body').addClass('mobile-modal-open');
        }

        // Imposta il focus sul primo elemento focusable
        setTimeout(function () {
            var $focusable = $modal.find(focusableElementsString);

            if ($focusable.length > 0) {
                $focusable.first().focus();
                trapIndex = 0;
            } else {
                // Se non ci sono elementi focalizzabili, imposta il focus sul dialogo stesso
                $modal.focus();
            }
        }, 100);
    }

    function closeModal(modalId) {
        var $modal = $('[data-modal-dialog="' + modalId + '"]');

        if ($modal.length === 0) return;

        // Array di submenu speciali che richiedono un trattamento particolare
        var specialSubmenus = [
            "submenu-mobile-prodotti",
            "submenu-mobile-progetti",
            "submenu-mobile-servizi",
            "submenu-mobile-azienda"
        ];

        // Controlla se era una vista mobile
        var wasMobileView = $modal.hasClass('mobile-view');

        // Rimuovi la classe active
        $modal.removeClass('active');
        $modal.removeClass('mobile-view');
        $modal.attr('aria-hidden', 'true');
        $modal.removeAttr('tabindex');

        // Se è uno dei submenu speciali in mobile, rimuovi anche la classe active dal submenu-mobile
        if (specialSubmenus.includes(modalId) && window.innerWidth < 768) {
            console.log('Rimozione classe active da submenu-mobile per:', modalId);
            $('.submenu.submenu-mobile').removeClass('active');
        }

        // Rimuovi questo modal dalla storia
        var modalIndex = modalHistory.indexOf(modalId);
        if (modalIndex !== -1) {
            modalHistory.splice(modalIndex, 1);
            console.log('Modal rimosso dalla storia:', modalId);
            console.log('Storia modal aggiornata:', modalHistory);
        }

        // Se ci sono ancora modal nella storia, imposta l'ultimo come currentModal
        if (modalHistory.length > 0) {
            currentModal = modalHistory[modalHistory.length - 1];
            console.log('Current modal aggiornato a:', currentModal);
        } else {
            // Altrimenti, resetta currentModal
            currentModal = null;

            // Ripristina il focus precedente solo quando non ci sono più modal aperti
            if (previousFocus && typeof previousFocus.focus === 'function') {
                previousFocus.focus();
            }
        }

        // Abilita lo scroll di sfondo solo se non ci sono più modal attivi
        if ($('[data-modal-dialog].active').length === 0) {
            $('body').removeClass('modal-open');
            if (wasMobileView) {
                $('body').removeClass('mobile-modal-open');
            }
        }
    }

    // Funzione per intrappolare il tab key all'interno del modale
    function trapTabKey(e) {
        var $modal = $('[data-modal-dialog="' + currentModal + '"]');
        var $focusable = $modal.find(focusableElementsString);

        if ($focusable.length === 0) return;

        var firstFocusableElement = $focusable[0];
        var lastFocusableElement = $focusable[$focusable.length - 1];

        // Se si preme Shift+Tab e si è sul primo elemento focusabile,
        // sposta il focus sull'ultimo elemento
        if (e.shiftKey && document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
        }
        // Se si preme Tab e si è sull'ultimo elemento focusabile,
        // sposta il focus sul primo elemento
        else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
        }
    }
}

function tabIndexLabel() {
    // Seleziona tutte le label con tabindex
    $('label[tabindex="0"]').on('keydown', function (e) {
        // Attiva il click quando si preme Spazio o Invio
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault(); // Previeni lo scroll della pagina

            // Salva un riferimento alla label corrente
            var $currentLabel = $(this);

            // Memorizza la posizione di scroll attuale
            var scrollPos = $(window).scrollTop();

            // Recupera l'id del radio button associato
            var radioId = $currentLabel.attr('for');

            // Seleziona il radio button e imposta checked a true
            $('#' + radioId).prop('checked', true).trigger('change');

            // Ripristina la posizione di scroll (previene lo scroll automatico)
            $(window).scrollTop(scrollPos);

            // Importante: riporta il focus sulla label dopo un breve delay
            // Il timeout è necessario per dare tempo al browser di completare 
            // l'elaborazione dell'evento change
            setTimeout(function () {
                $currentLabel.focus();

                // Assicurati che lo scroll rimanga dove era
                $(window).scrollTop(scrollPos);
            }, 10);

            console.log('Ho selezionato il radio: ' + radioId + ' e mantenuto il focus sulla label');
        }
    });
}

function tabindexRisultati() {
	$('.lista-risultati .box-prodotto .slide-dimensioni .thumbnail').attr('tabindex', '1');
}



/*--------------------------------------------------
DOC READY
--------------------------------------------------*/
$(document).ready(function (e) {
    initSkipLinks();
    initFocusTrap();
    //tabIndexLabel();
});


/*--------------------------------------------------
WIN RESIZE
--------------------------------------------------*/
$(window).resize(function () {

});

/*--------------------------------------------------
WIN LOAD
--------------------------------------------------*/
$(window).load(function () {
	tabindexRisultati();
});

/*--------------------------------------------------
WIN SCROLL
--------------------------------------------------*/
$(window).scroll(function (e) {

});
